module.exports = __webpack_public_path__ + "img/stream-goal-completed.621f306d.gif";